import { ReactNode } from 'react';

import {
  DropdownMenuItemRouter,
  PageHeaderDropdownMenuItem,
} from './PageHeaderDropdownMenu';

type Props = {
  to: string;
  isStaff?: boolean;
  children: ReactNode;
  onClick: () => void;
};

export function PageHeaderAccountDropdownConditionalMenuItem({
  to,
  isStaff,
  children,
  onClick,
}: Props) {
  if (isStaff) {
    return (
      <PageHeaderDropdownMenuItem href={to} onClick={onClick}>
        {children}
      </PageHeaderDropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItemRouter onClick={onClick} to={to}>
      {children}
    </DropdownMenuItemRouter>
  );
}
